import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { GoogleAnalyticsService } from '@core/services/google-analytics.service';
import { UiTranslationService } from '@core/services/ui-translation.service';

@Component({
  selector: 'app-analytics-consent',
  templateUrl: './analytics-consent.html',
  styleUrl: './analytics-consent.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalyticsConsent {
  protected readonly analytics = inject(GoogleAnalyticsService);
  protected readonly i18n =
    inject(UiTranslationService).namespace('analyticsConsent');
  protected choose(accept: boolean): void {
    if (accept) this.analytics.accept();
    else this.analytics.decline();
  }
}
